import decode from 'jwt-decode'

const AUTH_TOKEN_KEY = 'adm'

export function getAuthToken() {
  const storedToken = localStorage.getItem(AUTH_TOKEN_KEY)

  if (!storedToken) {
    return null
  }

  try {
    const parsedToken = JSON.parse(storedToken)
    return typeof parsedToken === 'string' ? parsedToken : storedToken
  } catch (error) {
    return storedToken
  }
}

export function isLoggedIn() {
  const authToken = getAuthToken()
  return !!authToken && !isTokenExpired(authToken)
}

export function getUserInfo() {
  const authToken = getAuthToken()

  if (!authToken || isTokenExpired(authToken)) {
    return null
  }

  try {
    return decode(authToken)
  } catch (error) {
    return null
  }
}

function getTokenExpirationDate(encodedToken) {
  try {
    const token = decode(encodedToken)

    if (!token.exp) {
      return null
    }

    const date = new Date(0)
    date.setUTCSeconds(token.exp)

    return date
  } catch (error) {
    return null
  }
}

function isTokenExpired(token) {
  const expirationDate = getTokenExpirationDate(token)
  return !expirationDate || expirationDate < new Date()
}
